import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import SchedulePage from "@/pages/SchedulePage";
import Register from "@/pages/Register";
import MyFamily from "@/pages/MyFamily";
import Photos from "@/pages/Photos";
import CheckIn from "@/pages/CheckIn";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/register" element={<Register />} />
            <Route path="/my-family" element={<MyFamily />} />
            <Route path="/photos" element={<Photos />} />
          </Route>
          <Route path="/checkin" element={<CheckIn />} />
          <Route path="/organizer/login" element={<AdminLogin />} />
          <Route path="/organizer" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" offset={96} duration={2500} richColors toastOptions={{ style: { fontSize: "1rem" } }} />
    </div>
  );
}

export default App;
